/* AddRangeComponent.js */

"use strict";
const _ = require("lodash");
const Renderer = require("./AddRangeRenderer");

class AddEditRangeComponent {
    constructor(logger, context, title) {
        this._logger = logger;
        this._context = context;
        this._title = title || "Edit Range";

        if (!_.isEmpty(this._context)) {
            if (
                _.get(this._context, "type", "") === "ipRange" ||
                _.get(this._context, "type", "") === "range"
            ) {
                this._type = "ipRange";
                const startAndEnd = _.get(this._context, "ipRangeValues", "").split(" - ");
                this._start = _.trim(startAndEnd[0]);
                this._end = _.trim(startAndEnd[1]);
            } else {
                this._type = "ipBlock";
                const vals = _.get(this._context, "ipRangeValues", "").split("/");
                this._ipAdd = _.trim(vals[0]);
                this._subnet = _.trim(vals[1]);
                if (this._subnet) {
                    this._subnet = parseInt(this._subnet, 10);
                }
            }
        }

        this._renderer = new Renderer(this);
        this._renderer.render();
        this._context = undefined;
    }

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        return this._renderer.shutdown().then(
            () => {
                this._renderer = undefined;
                this._context = undefined;
            },
            (err) => {
                this._logger.warn({error: err}, "BaseCreateComponent.shutdown() error");
            }
        );
    }

    createAction(res) {
        this._context.resolve(res);
    }

    cancelAction() {
        this._context.reject({userRejected: true});
    }

    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
      this._context = context;
    }
}
module.exports = AddEditRangeComponent;
